const DiscordAltIcon = ({ color = "white", size}) => {

  return (
    <svg
      width={size || "34"}
      height={size || "30"}
      viewBox="0 0 34 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 7.5C15.3333 5.5 18.6667 5.5 24.5 7.5"
        stroke={color}
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 22.5C14.75 24.5 19.25 24.5 24.5 22.5"
        stroke={color}
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2856 23.4375C12.2856 25.125 9.10408 28.5 8.28809 28.5C5.83842 28.5 3.66302 25.6869 2.57447 23.4375C1.48591 20.6244 1.75848 13.5943 5.02243 4.03125C7.40182 2.31844 9.79149 1.77 12.2857 1.5L14 6"
        stroke={color}
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.7144 23.4375C21.7144 25.125 24.8959 28.5 25.7119 28.5C28.1616 28.5 30.337 25.6869 31.4255 23.4375C32.5141 20.6244 32.2415 13.5943 28.9776 4.03125C26.5982 2.31844 24.2085 1.77 21.7143 1.5L20 6"
        stroke={color}
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2651 15H10.25M23.75 15H23.7349"
        stroke={color}
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DiscordAltIcon;
